import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    max-width: 512px;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    scrollbar-width: none;
    margin: auto;
`;
